import React from 'react';
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Card, CardActionArea, CardContent, DialogTitle, Grid } from '@mui/material';
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { formatDateAttachment } from "../../../../../../../../../../utils/time";

const AttachmentDialog = ({ open, onClose, data }) => {
    const anexos = data.anexos
    const anexosFiltrados = anexos?.filter(i => i?.pdf?.nome);
    return (
        <Dialog
            fullWidth
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>Anexos</DialogTitle>
            <DialogContent style={{ display: 'flex', flexDirection: 'row' }}>
                <Grid container spacing={3}>
                    {anexosFiltrados?.map((anexo) => (
                        <Grid item md={12} key={anexo?.tema}>
                            <Card>
                                <CardActionArea>
                                    <CardContent>
                                        <Grid container spacing={1} justifyContent="center" alignItems="center">
                                            <Grid item xs={12} >
                                                {!!anexo?.pdf?.nomeAmigavel && (
                                                    <Typography variant="subtitle2">
                                                        <strong>{anexo?.pdf?.nomeAmigavel}</strong>
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} >
                                                {!!anexo?.tema && (
                                                    <Typography variant="body2" component="div">
                                                        <b>Tema:</b> {anexo?.tema}
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} container alignItems="center" justifyContent="space-between">
                                                <Typography variant="body2" component="div">
                                                    <b>Data:</b> {formatDateAttachment(anexo?.pdf?.nome)}
                                                </Typography>
                                                <Button
                                                    size="small"
                                                    href={anexo?.pdf?.urlConteudo}
                                                    target="_blank"
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Visualizar Arquivo
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AttachmentDialog;
